import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { brandsLogo } from 'scenes/V3/ATLandingPage/assets';
import { withQueryParamCapture } from '@helpers/useQueryParamCapture';
import {
  FAQSection,
  HowItWorksSection,
  TestimonialsSection,
  WelcomeSection,
  JoinATSection,
} from './Sections';
import './ATLandingPage.scss';
import { getReferralCodeWithFallback } from '@helpers/referralHero';
import { verifyGoogleAdsParams } from '@helpers/localStorage';
import TrackingService from 'services/TrackingService';

class ATLandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referral: getReferralCodeWithFallback(this.props.location),
      ga: verifyGoogleAdsParams(this.props.location),
      brands: {
        active: false,
      },
    };
    this.brandsCarouselRef = React.createRef();
  }

  componentDidMount() {
    const trackingService = new TrackingService(this.props.session);
    trackingService.trackMixpanel({
      event_name: '/athletic-trainers',
      event_data: {
        referral: this.state.referral,
        ga: this.state.ga,
      },
    });

    if (this.brandsCarouselRef.current) {
      this.resizeObserver = new ResizeObserver(() => this.checkOverflow(this.brandsCarouselRef));
      this.resizeObserver.observe(this.brandsCarouselRef.current);
    }

    // Query params are automatically captured by withQueryParamCapture HOC

    setTimeout(() => {
      this.initScrollAnimations();
    }, 100);
  }

  initScrollAnimations = () => {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -100px 0px',
      threshold: 0.15,
    };

    this.scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');

          this.scrollObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.scroll-animate');
    animatedElements.forEach(el => this.scrollObserver.observe(el));
  };

  componentWillUnmount() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.scrollObserver) this.scrollObserver.disconnect();
  }

  checkOverflow = ref => {
    if (!ref.current) return false;

    const isActive = this.brandsCarouselRef.current.scrollWidth > window.innerWidth;

    this.setState(prevState => ({
      ...prevState,
      brands: {
        ...prevState.brands,
        active: isActive,
      },
    }));

    return isActive;
  };

  onImReady = () => {
    const trackingService = new TrackingService(this.props.session);
    trackingService.trackMixpanel({
      event_name: 'ATLandingPageGetStarted',
      event_data: {
        referral: this.state.referral,
        ga: this.state.ga,
      },
    });

    this.props.history.push('/create-account/role');
  };

  institutionsLogoSlides = () => {
    return brandsLogo.map((image, index) => (
      <div className="embla__slide brands" key={`brand-logo-${index}`}>
        <img
          src={image.imageUrl}
          alt={`Institution logo ${index + 1}`}
          className="institution-logo"
          width={image.width}
          height={image.height}
          style={image.objectFit ? { objectFit: image.objectFit } : undefined}
        />
      </div>
    ));
  };

  render() {
    return (
      <div className="atLandingPage">
        <main className="content">
          <WelcomeSection
            onImReady={this.onImReady}
            institutionsLogoSlides={this.institutionsLogoSlides}
            brandsCarouselRef={this.brandsCarouselRef}
            brands={this.state.brands}
          />
          <HowItWorksSection />
          <TestimonialsSection />
          <FAQSection />
          <JoinATSection onImReady={this.onImReady} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.session.currentUser,
  session: state.session,
});

// Wrap with HOC to automatically capture query parameters
export default withQueryParamCapture(withRouter(connect(mapStateToProps)(ATLandingPage)));
